// src/components/Dashboard/Tabs/Materials/Component/AddMaterialModal.jsx
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { createMaterial } from '../../../../../../../Redux/Projects/Material/materialSlice';
import { showFeedback } from '../../../../../../../Redux/UI/uiFeedbackSlice';
import '../../../../../../../Stylesheets/Dashboard/Tabs/Materials/AddMaterialModal.css';

const AddMaterialModal = ({ onClose, currentProjectId }) => {
  const dispatch = useDispatch();

  const [form, setForm] = useState({
    name: '',
    unit: '',
    quantity: '',
    rate: '',
    vendor: '',
    location: '',
    minThreshold: '',
  });

  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    const name = form.name.trim();
    const unit = form.unit.trim();
    const qty = Number(form.quantity);

    if (!currentProjectId) {
      dispatch(showFeedback({ type: 'error', title: 'No project', message: 'Project not selected.' }));
      return;
    }

    if (!name || !unit) {
      dispatch(showFeedback({ type: 'warning', title: 'Missing fields', message: 'Material name and unit are required.' }));
      return;
    }

    if (!Number.isFinite(qty) || qty <= 0) {
      dispatch(showFeedback({ type: 'warning', title: 'Invalid quantity', message: 'Enter a valid quantity (opening stock).' }));
      return;
    }

    setSubmitting(true);

    try {
      const formData = {
        name,
        unit,
        quantity: qty, // if you keep this field as opening stock
        rate: Number(form.rate) || 0,
        vendor: (form.vendor || '').trim(),
        location: (form.location || '').trim(),
        minThreshold: Number(form.minThreshold) || 0,
      };

      const action = await dispatch(createMaterial({ formData, projectId: currentProjectId }));

      if (createMaterial.fulfilled.match(action)) {
        dispatch(showFeedback({
          type: 'success',
          title: 'Material added',
          message: 'Material created. Use “Receive” to add more stock and upload bills.',
        }));
        onClose?.();
        return;
      }

      const msg =
        action.payload?.message ||
        action.error?.message ||
        action.payload ||
        'Failed to add material.';

      dispatch(showFeedback({ type: 'error', title: 'Add failed', message: String(msg) }));
    } catch (err) {
      dispatch(showFeedback({ type: 'error', title: 'Error', message: err?.message || 'Unexpected error while adding material.' }));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="material-tab-modal-overlay" onMouseDown={onClose}>
      <div className="material-tab-modal" onMouseDown={(e) => e.stopPropagation()}>
        <div className="material-tab-modal-header">
          <h2>Add New Material</h2>
          <button className="material-tab-modal-close" onClick={onClose} aria-label="Close">×</button>
        </div>

        <div className="material-tab-form">
          <div className="material-tab-row">
            <div className="material-tab-field">
              <label>Material Name <span>*</span></label>
              <input name="name" type="text" value={form.name} onChange={handleChange} disabled={submitting} />
            </div>
            <div className="material-tab-field">
              <label>Unit of Measurement <span>*</span></label>
              <input name="unit" type="text" value={form.unit} onChange={handleChange} disabled={submitting} />
            </div>
          </div>

          <div className="material-tab-row">
            {/* <div className="material-tab-field">
              <label>Quantity (Opening Stock) <span>*</span></label>
              <input name="quantity" type="number" value={form.quantity} onChange={handleChange} disabled={submitting} />
            </div> */}
            <div className="material-tab-field">
              <label>Vendor</label>
              <input name="vendor" type="text" value={form.vendor} onChange={handleChange} disabled={submitting} />
            </div>
          </div>

          <div className="material-tab-row">
            <div className="material-tab-field">
              <label>Rate per Unit</label>
              <input name="rate" type="number" value={form.rate} onChange={handleChange} disabled={submitting} />
            </div>
            <div className="material-tab-field">
              <label>Storage Location</label>
              <input name="location" type="text" value={form.location} onChange={handleChange} disabled={submitting} />
            </div>
          </div>

          <div className="material-tab-row">
            <div className="material-tab-field">
              <label>Minimum Stock Level</label>
              <input name="minThreshold" type="number" value={form.minThreshold} onChange={handleChange} disabled={submitting} />
            </div>
            <div className="material-tab-field">
              <label>Note:</label>
              <p style={{ fontSize: '14px', color: '#888' }}>
                Bills are uploaded after you “Receive” stock.
              </p>
            </div>
          </div>
        </div>

        <div className="material-tab-footer">
          <button className="btn black" onClick={handleSubmit} disabled={submitting}>
            {submitting ? 'Adding…' : 'Add Material'}
          </button>
          <button className="btn cancel" onClick={onClose} disabled={submitting}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default AddMaterialModal;
